import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "line_break",
    standalone: false
})
export class LineBreakPipe implements PipeTransform {
    transform(text: string): string {
    return text.replaceAll(",","\n")
    }
}